globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.AnalyticsClickEvent = (function() {
  utils.include(AnalyticsClickEvent, appVisitor.modules.AnalyticsEventTrackable);

  function AnalyticsClickEvent($html) {
    this.$html = $html;
    this.analyticsEventData = this.$html.data("analytics-events-params");

    if(this.analyticsEventData) { this.init() };
  }

  $.extend(AnalyticsClickEvent.prototype, {
    init: function() {
      var _this = this;
      this.setAnalyticsEvent(_this.analyticsEventData, function() {
        _this.$html.one('click', function() {
          _this.sendAnalyticsEvent();
        });
      });
    }
  });

  return AnalyticsClickEvent;
})();
